// extracted by mini-css-extract-plugin
module.exports = {"lists":"TasksList_lists__3VulS","list":"TasksList_list__13YnR"};